// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-dialog {
  width: 100%;
  max-width: 650px;
  border-radius: 12px;
  overflow: visible;
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.confirmation-dialog .dialog-header {
  padding: 20px 24px;
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border-bottom: 1px solid #e0e0e0;
}
.confirmation-dialog .dialog-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  flex: 1;
  line-height: 1.3;
}
.confirmation-dialog .dialog-header .close-button {
  color: #6b7280;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: transparent;
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
}
.confirmation-dialog .dialog-header .close-button:hover {
  background: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
}
.confirmation-dialog .dialog-header .close-button:active {
  background: #e5e7eb;
  transform: scale(0.95);
}
.confirmation-dialog .dialog-header .close-button:focus {
  outline: none;
}
.confirmation-dialog .dialog-header .close-button:focus-visible {
  outline: none;
}
.confirmation-dialog .dialog-header .close-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirmation-dialog .confirmation-content {
  padding: 0 24px 24px;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.confirmation-dialog .confirmation-content .status-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px 0 20px;
}
.confirmation-dialog .confirmation-content .status-icon .icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  transition: all 0.3s ease;
}
.confirmation-dialog .confirmation-content .status-icon .icon-circle.approve {
  background-color: #e8f5e8;
  color: #2e7d32;
  border: 2px solid #4caf50;
}
.confirmation-dialog .confirmation-content .status-icon .icon-circle.reject {
  background-color: #ffebee;
  color: #c62828;
  border: 2px solid #f44336;
}
.confirmation-dialog .confirmation-content .status-icon .icon-circle.rework {
  background-color: #fff3e0;
  color: #ef6c00;
  border: 2px solid #ff9800;
}
.confirmation-dialog .confirmation-content .status-icon .icon-circle.cancel {
  background-color: #f3e5f5;
  color: #7b1fa2;
  border: 2px solid #9c27b0;
}
.confirmation-dialog .confirmation-content .confirmation-message {
  margin-bottom: 24px;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  border-left: 4px solid #2196f3;
  font-size: 16px;
  line-height: 1.6;
  color: #333;
}
.confirmation-dialog .confirmation-content .request-details {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.confirmation-dialog .confirmation-content .request-details .section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}
.confirmation-dialog .confirmation-content .request-details .detail-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  gap: 0;
  min-height: 24px;
}
.confirmation-dialog .confirmation-content .request-details .detail-item:last-child {
  margin-bottom: 0;
}
.confirmation-dialog .confirmation-content .request-details .detail-item .label {
  font-weight: 600;
  color: #666;
  min-width: 120px;
  flex-shrink: 0;
  text-align: right;
  padding-right: 16px;
  font-size: 14px;
  line-height: 1.4;
}
.confirmation-dialog .confirmation-content .request-details .detail-item .value {
  color: #333;
  flex: 1;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.4;
  padding-left: 8px;
  font-weight: 500;
}
@media (max-width: 600px) {
  .confirmation-dialog .confirmation-content .request-details {
    padding: 16px;
  }
  .confirmation-dialog .confirmation-content .request-details .detail-item {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }
  .confirmation-dialog .confirmation-content .request-details .detail-item .label {
    min-width: auto;
    text-align: left;
    padding-right: 0;
    padding-bottom: 4px;
    font-size: 13px;
    color: #555;
  }
  .confirmation-dialog .confirmation-content .request-details .detail-item .value {
    padding-left: 0;
    font-size: 14px;
    font-weight: 600;
    color: #222;
  }
}
.confirmation-dialog .confirmation-content .comment-section {
  margin-top: 24px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}
.confirmation-dialog .confirmation-content .comment-section .section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}
.confirmation-dialog .confirmation-content .comment-section mat-form-field {
  margin-top: 8px;
  width: 100%;
}
.confirmation-dialog .confirmation-content .comment-section mat-form-field textarea {
  font-size: 14px;
  line-height: 1.5;
}
.confirmation-dialog .confirmation-content .comment-section mat-form-field .mat-form-field-wrapper {
  padding-bottom: 0;
}
.confirmation-dialog .confirmation-content .comment-section mat-form-field .mat-form-field-underline {
  display: none;
}
.confirmation-dialog .confirmation-content .comment-section mat-form-field .mat-form-field-outline {
  border-radius: 6px;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions {
  padding: 16px 24px !important;
  margin: 0 !important;
  border-top: 1px solid #e0e0e0 !important;
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  align-content: center !important;
  gap: 12px !important;
  background-color: #fafafa !important;
  flex-shrink: 0;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button {
  min-width: 100px !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-radius: 6px !important;
  transition: all 0.3s ease !important;
  padding: 10px 20px !important;
  border: none !important;
  cursor: pointer !important;
  font-family: inherit !important;
  height: auto !important;
  line-height: 1.2 !important;
  margin: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  align-self: center !important;
  justify-content: center !important;
  vertical-align: middle !important;
  background-color: transparent !important;
  color: inherit !important;
  border: inherit !important;
  box-shadow: none !important;
  outline: none !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.cancel-btn,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.cancel-btn {
  color: #666 !important;
  border: 1px solid #ddd !important;
  background-color: #f8f9fa !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.cancel-btn:hover,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.cancel-btn:hover {
  background-color: #e9ecef !important;
  border-color: #adb5bd !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.cancel-btn:active,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.cancel-btn:active {
  transform: translateY(0) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn {
  color: white !important;
  border: none !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.approve,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.approve {
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.approve:hover,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.approve:hover {
  background: linear-gradient(135deg, #45a049 0%, #388e3c 100%) !important;
  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3) !important;
  transform: translateY(-1px) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.approve:active,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.approve:active {
  transform: translateY(0) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.reject,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.reject {
  background: linear-gradient(135deg, #f44336 0%, #da190b 100%) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.reject:hover,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.reject:hover {
  background: linear-gradient(135deg, #da190b 0%, #c62828 100%) !important;
  box-shadow: 0 4px 8px rgba(244, 67, 54, 0.3) !important;
  transform: translateY(-1px) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.reject:active,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.reject:active {
  transform: translateY(0) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.rework,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.rework {
  background: linear-gradient(135deg, #ff9800 0%, #e68900 100%) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.rework:hover,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.rework:hover {
  background: linear-gradient(135deg, #e68900 0%, #ef6c00 100%) !important;
  box-shadow: 0 4px 8px rgba(255, 152, 0, 0.3) !important;
  transform: translateY(-1px) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.rework:active,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.rework:active {
  transform: translateY(0) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.cancel,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.cancel {
  background: linear-gradient(135deg, #9e9e9e 0%, #757575 100%) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.cancel:hover,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.cancel:hover {
  background: linear-gradient(135deg, #757575 0%, #616161 100%) !important;
  box-shadow: 0 4px 8px rgba(158, 158, 158, 0.3) !important;
  transform: translateY(-1px) !important;
}
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-button.confirm-btn.cancel:active,
.confirmation-dialog mat-dialog-actions.mat-dialog-actions button.mat-raised-button.confirm-btn.cancel:active {
  transform: translateY(0) !important;
}

.confirmation-dialog mat-dialog-actions button.mat-button.cancel-btn {
  color: #666 !important;
  border: 1px solid #ddd !important;
  background-color: #f8f9fa !important;
}

.confirmation-dialog mat-dialog-actions button.mat-raised-button.confirm-btn.approve {
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;
  color: white !important;
  border: none !important;
}

::ng-deep .mat-dialog-container {
  display: flex !important;
  flex-direction: column !important;
  padding: 0 !important;
  max-height: 90vh !important;
  overflow: visible !important;
  box-sizing: border-box !important;
}

::ng-deep .confirmation-dialog mat-dialog-actions {
  justify-content: flex-end !important;
  align-items: center !important;
}

.confirmation-dialog {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.dialog-header {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
}

.confirmation-content {
  overflow-y: auto;
}

mat-dialog-actions.mat-dialog-actions {
  position: sticky;
  bottom: 0;
  background: #fafafa;
  z-index: 2;
}

/* Align actions */
mat-dialog-actions.mat-dialog-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
}

/* Normalize MDC buttons inside actions */
mat-dialog-actions .mat-mdc-button-base {
  height: 40px;
  min-width: 120px;
  padding: 0 16px;
  margin: 6px;
  border-radius: 4px;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Ensure the internal MDC label area uses flex for icon/text alignment */
mat-dialog-actions .mat-mdc-button-base .mdc-button__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 1;
}

/* Standardize icon size/alignment */
mat-dialog-actions .mat-mdc-button-base .mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
}

/* Visual for cancel button to match sizing */
.cancel-btn {
  border: 1px solid #ddd;
  background-color: #f8f9fa;
  color: #444;
}

@media (max-width: 600px) {
  mat-dialog-actions.mat-dialog-actions {
    flex-direction: column;
    align-items: stretch;
  }
  mat-dialog-actions .mat-mdc-button-base {
    width: 100%;
    margin: 6px 0;
  }
}
@media (max-width: 600px) {
  .confirmation-dialog {
    width: calc(100vw - 24px);
    max-width: 415px;
    margin: 12px auto;
    border-radius: 0;
    max-height: 100vh;
  }
  .confirmation-dialog .dialog-header {
    padding: 16px 16px 0;
  }
  .confirmation-dialog .dialog-header h2 {
    font-size: 18px;
    line-height: 1.2;
  }
  .confirmation-dialog .dialog-header .close-button {
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
  }
  .confirmation-dialog .dialog-header .close-button mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .confirmation-dialog .confirmation-content {
    padding: 12px 16px 16px;
    max-height: calc(100vh - 140px);
    overflow-y: auto;
  }
  .confirmation-dialog mat-dialog-actions {
    position: sticky;
    bottom: 0;
    background: #fafafa;
    flex-direction: column !important;
  }
  .confirmation-dialog mat-dialog-actions button {
    width: 100% !important;
    margin-bottom: 8px !important;
  }
  .confirmation-dialog mat-dialog-actions button:last-child {
    margin-bottom: 0 !important;
  }
  ::ng-deep .mat-dialog-container {
    max-height: 100vh !important;
  }
}
::ng-deep .confirmation-dialog mat-dialog-actions button.mat-button.cancel-btn {
  color: #666 !important;
  border: 1px solid #ddd !important;
  background-color: #f8f9fa !important;
  background-image: none !important;
}
::ng-deep .confirmation-dialog mat-dialog-actions button.mat-raised-button.confirm-btn.approve {
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;
  background-image: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;
  color: white !important;
  border: none !important;
  background-color: transparent !important;
}

/* Comment Form Styling */
.comment-form-section {
  margin: 20px 24px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.comment-form-section .example-form {
  margin: 0;
}
.comment-form-section .example-form .w-100 {
  width: 100%;
}
.comment-form-section .example-form .font16 {
  font-size: 16px;
  font-weight: 500;
  color: #495057;
}
.comment-form-section .example-form mat-form-field {
  width: 100%;
}
.comment-form-section .example-form mat-form-field .mat-mdc-form-field {
  width: 100%;
}
.comment-form-section .example-form mat-form-field .mat-mdc-text-field-wrapper {
  background-color: #fff;
  border-radius: 6px;
}
.comment-form-section .example-form mat-form-field .mat-mdc-form-field-focus-overlay {
  background-color: transparent;
}
.comment-form-section .example-form mat-form-field input {
  font-size: 14px;
  color: #495057;
}
.comment-form-section .example-form mat-form-field input::placeholder {
  color: #6c757d;
  opacity: 0.7;
}
.comment-form-section .example-form mat-form-field .mat-mdc-form-field-hint {
  color: #6c757d;
  font-size: 12px;
}

@media (max-width: 600px) {
  .comment-form-section {
    margin: 12px 12px;
    padding: 12px;
  }
}
/* Spacing adjustments for better padding */
.dialog-header {
  padding: 16px 24px 0;
}

.confirmation-content {
  padding: 16px 24px 16px;
}

.comment-form-section {
  margin: 16px 24px;
  padding: 16px;
}

mat-dialog-actions.mat-dialog-actions {
  padding: 12px 24px;
}

/* Add border on all sides for action buttons */
mat-dialog-actions.mat-dialog-actions button.mat-button,
mat-dialog-actions.mat-dialog-actions button.mat-raised-button,
mat-dialog-actions .mat-mdc-button-base {
  border: 1px solid #ddd;
}

body.theme-dark .mat-mdc-dialog-container,
body.theme-dark .mdc-dialog__container,
body.theme-dark .mdc-dialog__surface {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dialog-content,
body.theme-dark .dialog-body,
body.theme-dark .modal-content,
body.theme-dark .confirmation-dialog,
body.theme-dark .response-dialog {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dialog-content input,
body.theme-dark .dialog-body input,
body.theme-dark .dialog-content select,
body.theme-dark .dialog-body select,
body.theme-dark .dialog-content textarea,
body.theme-dark .dialog-body textarea {
  background: #0f172a !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dialog-content p,
body.theme-dark .dialog-body p,
body.theme-dark .dialog-content span:not(.material-icons),
body.theme-dark .dialog-body span:not(.material-icons),
body.theme-dark .dialog-content label,
body.theme-dark .dialog-body label,
body.theme-dark .dialog-content h1,
body.theme-dark .dialog-body h1,
body.theme-dark .dialog-content h2,
body.theme-dark .dialog-body h2,
body.theme-dark .dialog-content h3,
body.theme-dark .dialog-body h3 {
  color: var(--fc-fg) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/access-requests/access-request-response-dialog/access-request-response-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AACF;AACE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AACJ;AACI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;EACA,gBAAA;AACN;AAEI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AAAN;AAEM;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAAR;AAGM;EACE,mBAAA;EACA,sBAAA;AADR;AAIM;EACE,aAAA;AAFR;AAKM;EACE,aAAA;AAHR;AAMM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AASE;EACE,oBAAA;EACA,OAAA;EACA,gBAAA;EACA,iCAAA;AAPJ;AASI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAPN;AASM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAPR;AASQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAPV;AAUQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AARV;AAWQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AATV;AAYQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAVV;AAeI;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAbN;AAgBI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;AAdN;AAgBM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;AAdR;AAiBM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,MAAA;EACA,gBAAA;AAfR;AAiBQ;EACE,gBAAA;AAfV;AAkBQ;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAhBV;AAmBQ;EACE,WAAA;EACA,OAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAjBV;AAsBM;EAnDF;IAoDI,aAAA;EAnBN;EAqBM;IACE,sBAAA;IACA,uBAAA;IACA,mBAAA;EAnBR;EAqBQ;IACE,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;IACA,eAAA;IACA,WAAA;EAnBV;EAsBQ;IACE,eAAA;IACA,eAAA;IACA,gBAAA;IACA,WAAA;EApBV;AACF;AAyBI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAvBN;AAyBM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;AAvBR;AA0BM;EACE,eAAA;EACA,WAAA;AAxBR;AA0BQ;EACE,eAAA;EACA,gBAAA;AAxBV;AA2BQ;EACE,iBAAA;AAzBV;AA4BQ;EACE,aAAA;AA1BV;AA6BQ;EACE,kBAAA;AA3BV;AAkCE;EACE,6BAAA;EACA,oBAAA;EACA,wCAAA;EACA,wBAAA;EACA,oCAAA;EACA,8BAAA;EACA,gCAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;AAhCJ;AAkCI;;EAEE,2BAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;EACA,6BAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,0BAAA;EACA,+BAAA;EACA,uBAAA;EACA,2BAAA;EACA,oBAAA;EACA,wBAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,kCAAA;EACA,iCAAA;EAGA,wCAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,wBAAA;AAlCN;AAoCM;;EACE,sBAAA;EACA,iCAAA;EACA,oCAAA;AAjCR;AAmCQ;;EACE,oCAAA;EACA,gCAAA;EACA,sCAAA;EACA,mDAAA;AAhCV;AAmCQ;;EACE,mCAAA;AAhCV;AAoCM;;EACE,uBAAA;EACA,uBAAA;EACA,mDAAA;AAjCR;AAmCQ;;EACE,wEAAA;AAhCV;AAsCU;;EACE,wEAAA;EAKA,uDAAA;EACA,sCAAA;AAvCZ;AA0CU;;EACE,mCAAA;AAvCZ;AA2CQ;;EACE,wEAAA;AAxCV;AA8CU;;EACE,wEAAA;EAKA,uDAAA;EACA,sCAAA;AA/CZ;AAkDU;;EACE,mCAAA;AA/CZ;AAmDQ;;EACE,wEAAA;AAhDV;AAsDU;;EACE,wEAAA;EAKA,uDAAA;EACA,sCAAA;AAvDZ;AA0DU;;EACE,mCAAA;AAvDZ;AA2DQ;;EACE,wEAAA;AAxDV;AA8DU;;EACE,wEAAA;EAKA,yDAAA;EACA,sCAAA;AA/DZ;AAkEU;;EACE,mCAAA;AA/DZ;;AAwEA;EACE,sBAAA;EACA,iCAAA;EACA,oCAAA;AArEF;;AAwEA;EAGE,wEAAA;EACA,uBAAA;EACA,uBAAA;AAvEF;;AA2EA;EACE,wBAAA;EACA,iCAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,iCAAA;AAxEF;;AA4EA;EACE,oCAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,UAAA;AAzEF;;AA4EA;EACE,gBAAA;AAzEF;;AA4EA;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;AAzEF;;AA4EA,kBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAzEF;;AA4EA,yCAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAzEF;;AA4EA,yEAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAzEF;;AA4EA,oCAAA;AACA;EACE,eAAA;EACA,YAAA;EACA,WAAA;AAzEF;;AA4EA,6CAAA;AACA;EACE,sBAAA;EACA,yBAAA;EACA,WAAA;AAzEF;;AA4EA;EACE;IACE,sBAAA;IACA,oBAAA;EAzEF;EA4EA;IACE,WAAA;IACA,aAAA;EA1EF;AACF;AA6EA;EACE;IACE,yBAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,iBAAA;EA3EF;EA6EE;IACE,oBAAA;EA3EJ;EA6EI;IACE,eAAA;IACA,gBAAA;EA3EN;EA8EI;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EA5EN;EA8EM;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA5ER;EAiFE;IACE,uBAAA;IACA,+BAAA;IACA,gBAAA;EA/EJ;EAkFE;IACE,gBAAA;IACA,SAAA;IACA,mBAAA;IACA,iCAAA;EAhFJ;EAkFI;IACE,sBAAA;IACA,6BAAA;EAhFN;EAkFM;IACE,2BAAA;EAhFR;EAsFA;IACE,4BAAA;EApFF;AACF;AA0FI;EACE,sBAAA;EACA,iCAAA;EACA,oCAAA;EACA,iCAAA;AAxFN;AA2FI;EACE,wEAAA;EACA,8EAAA;EAKA,uBAAA;EACA,uBAAA;EACA,wCAAA;AA7FN;;AAkGA,yBAAA;AACA;EACE,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AA/FF;AAiGE;EACE,SAAA;AA/FJ;AAiGI;EACE,WAAA;AA/FN;AAkGI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAhGN;AAmGI;EACE,WAAA;AAjGN;AAmGM;EACE,WAAA;AAjGR;AAoGM;EACE,sBAAA;EACA,kBAAA;AAlGR;AAqGM;EACE,6BAAA;AAnGR;AAsGM;EACE,eAAA;EACA,cAAA;AApGR;AAsGQ;EACE,cAAA;EACA,YAAA;AApGV;AAwGM;EACE,cAAA;EACA,eAAA;AAtGR;;AA4GA;EACE;IACE,iBAAA;IACA,aAAA;EAzGF;AACF;AA4GA,2CAAA;AACA;EACE,oBAAA;AA1GF;;AA6GA;EACE,uBAAA;AA1GF;;AA6GA;EACE,iBAAA;EACA,aAAA;AA1GF;;AA6GA;EACE,kBAAA;AA1GF;;AA6GA,+CAAA;AACA;;;EAGE,sBAAA;AA1GF;;AAiHA;;;EAGE,oCAAA;EACA,8BAAA;AA9GF;;AAiHA;;;;;EAKE,oCAAA;EACA,8BAAA;EACA,yCAAA;AA9GF;;AAiHA;;;;;;EAME,8BAAA;EACA,8BAAA;EACA,yCAAA;AA9GF;;AAiHA;;;;;;;;;;;;EAYE,8BAAA;AA9GF","sourcesContent":[".confirmation-dialog {\n  width: 100%;\n  max-width: 650px;\n  border-radius: 12px;\n  overflow: visible; // Changed from hidden to visible to prevent cutting off close button\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n\n  .dialog-header {\n    padding: 20px 24px;\n    margin-bottom: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    border-bottom: 1px solid #e0e0e0;\n\n    h2 {\n      margin: 0;\n      font-size: 20px;\n      font-weight: 600;\n      color: #111827;\n      flex: 1;\n      line-height: 1.3;\n    }\n\n    .close-button {\n      color: #6b7280;\n      width: 40px;\n      height: 40px;\n      min-width: 40px;\n      min-height: 40px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.2s ease;\n      background: transparent;\n      border: 1px solid transparent;\n      padding: 0;\n      margin: 0;\n\n      &:hover {\n        background: #f3f4f6;\n        color: #374151;\n        border-color: #e5e7eb;\n      }\n\n      &:active {\n        background: #e5e7eb;\n        transform: scale(0.95);\n      }\n\n      &:focus {\n        outline: none;\n      }\n\n      &:focus-visible {\n        outline: none;\n      }\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        line-height: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  .confirmation-content {\n    padding: 0 24px 24px;\n    flex: 1;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n\n    .status-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin: 24px 0 20px;\n\n      .icon-circle {\n        width: 60px;\n        height: 60px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 28px;\n        transition: all 0.3s ease;\n\n        &.approve {\n          background-color: #e8f5e8;\n          color: #2e7d32;\n          border: 2px solid #4caf50;\n        }\n\n        &.reject {\n          background-color: #ffebee;\n          color: #c62828;\n          border: 2px solid #f44336;\n        }\n\n        &.rework {\n          background-color: #fff3e0;\n          color: #ef6c00;\n          border: 2px solid #ff9800;\n        }\n\n        &.cancel {\n          background-color: #f3e5f5;\n          color: #7b1fa2;\n          border: 2px solid #9c27b0;\n        }\n      }\n    }\n\n    .confirmation-message {\n      margin-bottom: 24px;\n      padding: 16px;\n      background-color: #fff;\n      border-radius: 8px;\n      border-left: 4px solid #2196f3;\n      font-size: 16px;\n      line-height: 1.6;\n      color: #333;\n    }\n\n    .request-details {\n      background-color: #f8f9fa;\n      border-radius: 8px;\n      padding: 20px;\n      margin-bottom: 20px;\n      border: 1px solid #e9ecef;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n      .section-title {\n        font-size: 16px;\n        font-weight: 600;\n        color: #333;\n        margin-bottom: 16px;\n        padding-bottom: 8px;\n        border-bottom: 1px solid #e0e0e0;\n      }\n\n      .detail-item {\n        display: flex;\n        align-items: flex-start;\n        margin-bottom: 16px;\n        gap: 0;\n        min-height: 24px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n\n        .label {\n          font-weight: 600;\n          color: #666;\n          min-width: 120px;\n          flex-shrink: 0;\n          text-align: right;\n          padding-right: 16px;\n          font-size: 14px;\n          line-height: 1.4;\n        }\n\n        .value {\n          color: #333;\n          flex: 1;\n          word-break: break-word;\n          font-size: 14px;\n          line-height: 1.4;\n          padding-left: 8px;\n          font-weight: 500;\n        }\n      }\n\n      // Responsive design for smaller screens\n      @media (max-width: 600px) {\n        padding: 16px;\n\n        .detail-item {\n          flex-direction: column;\n          align-items: flex-start;\n          margin-bottom: 20px;\n\n          .label {\n            min-width: auto;\n            text-align: left;\n            padding-right: 0;\n            padding-bottom: 4px;\n            font-size: 13px;\n            color: #555;\n          }\n\n          .value {\n            padding-left: 0;\n            font-size: 14px;\n            font-weight: 600;\n            color: #222;\n          }\n        }\n      }\n    }\n\n    .comment-section {\n      margin-top: 24px;\n      padding: 20px;\n      background-color: #fff;\n      border-radius: 8px;\n      border: 1px solid #e0e0e0;\n\n      .section-title {\n        font-size: 16px;\n        font-weight: 600;\n        color: #333;\n        margin-bottom: 16px;\n        padding-bottom: 8px;\n        border-bottom: 1px solid #e0e0e0;\n      }\n\n      mat-form-field {\n        margin-top: 8px;\n        width: 100%;\n\n        textarea {\n          font-size: 14px;\n          line-height: 1.5;\n        }\n\n        .mat-form-field-wrapper {\n          padding-bottom: 0;\n        }\n\n        .mat-form-field-underline {\n          display: none;\n        }\n\n        .mat-form-field-outline {\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n\n  // Target Material Design dialog actions with more specific selectors\n  mat-dialog-actions.mat-dialog-actions {\n    padding: 16px 24px !important;\n    margin: 0 !important;\n    border-top: 1px solid #e0e0e0 !important;\n    display: flex !important;\n    justify-content: flex-end !important;\n    align-items: center !important;\n    align-content: center !important;\n    gap: 12px !important;\n    background-color: #fafafa !important;\n    flex-shrink: 0;\n\n    button.mat-button,\n    button.mat-raised-button {\n      min-width: 100px !important;\n      font-weight: 500 !important;\n      text-transform: uppercase !important;\n      letter-spacing: 0.5px !important;\n      border-radius: 6px !important;\n      transition: all 0.3s ease !important;\n      padding: 10px 20px !important;\n      border: none !important;\n      cursor: pointer !important;\n      font-family: inherit !important;\n      height: auto !important;\n      line-height: 1.2 !important;\n      margin: 0 !important;\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n      margin-left: 0 !important;\n      margin-right: 0 !important;\n      display: inline-flex !important;\n      align-items: center !important;\n      align-self: center !important;\n      justify-content: center !important;\n      vertical-align: middle !important;\n\n      // Override Material Design button styles completely\n      background-color: transparent !important;\n      color: inherit !important;\n      border: inherit !important;\n      box-shadow: none !important;\n      outline: none !important;\n\n      &.cancel-btn {\n        color: #666 !important;\n        border: 1px solid #ddd !important;\n        background-color: #f8f9fa !important;\n\n        &:hover {\n          background-color: #e9ecef !important;\n          border-color: #adb5bd !important;\n          transform: translateY(-1px) !important;\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n        }\n\n        &:active {\n          transform: translateY(0) !important;\n        }\n      }\n\n      &.confirm-btn {\n        color: white !important;\n        border: none !important;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n\n        &.approve {\n          background: linear-gradient(\n            135deg,\n            #4caf50 0%,\n            #45a049 100%\n          ) !important;\n\n          &:hover {\n            background: linear-gradient(\n              135deg,\n              #45a049 0%,\n              #388e3c 100%\n            ) !important;\n            box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3) !important;\n            transform: translateY(-1px) !important;\n          }\n\n          &:active {\n            transform: translateY(0) !important;\n          }\n        }\n\n        &.reject {\n          background: linear-gradient(\n            135deg,\n            #f44336 0%,\n            #da190b 100%\n          ) !important;\n\n          &:hover {\n            background: linear-gradient(\n              135deg,\n              #da190b 0%,\n              #c62828 100%\n            ) !important;\n            box-shadow: 0 4px 8px rgba(244, 67, 54, 0.3) !important;\n            transform: translateY(-1px) !important;\n          }\n\n          &:active {\n            transform: translateY(0) !important;\n          }\n        }\n\n        &.rework {\n          background: linear-gradient(\n            135deg,\n            #ff9800 0%,\n            #e68900 100%\n          ) !important;\n\n          &:hover {\n            background: linear-gradient(\n              135deg,\n              #e68900 0%,\n              #ef6c00 100%\n            ) !important;\n            box-shadow: 0 4px 8px rgba(255, 152, 0, 0.3) !important;\n            transform: translateY(-1px) !important;\n          }\n\n          &:active {\n            transform: translateY(0) !important;\n          }\n        }\n\n        &.cancel {\n          background: linear-gradient(\n            135deg,\n            #9e9e9e 0%,\n            #757575 100%\n          ) !important;\n\n          &:hover {\n            background: linear-gradient(\n              135deg,\n              #757575 0%,\n              #616161 100%\n            ) !important;\n            box-shadow: 0 4px 8px rgba(158, 158, 158, 0.3) !important;\n            transform: translateY(-1px) !important;\n          }\n\n          &:active {\n            transform: translateY(0) !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Additional global overrides for Material Design buttons - using more specific selectors\n.confirmation-dialog mat-dialog-actions button.mat-button.cancel-btn {\n  color: #666 !important;\n  border: 1px solid #ddd !important;\n  background-color: #f8f9fa !important;\n}\n\n.confirmation-dialog\n  mat-dialog-actions\n  button.mat-raised-button.confirm-btn.approve {\n  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;\n  color: white !important;\n  border: none !important;\n}\n\n// Ensure dialog is properly centered and not clipped\n::ng-deep .mat-dialog-container {\n  display: flex !important;\n  flex-direction: column !important;\n  padding: 0 !important;\n  max-height: 90vh !important;\n  overflow: visible !important;\n  box-sizing: border-box !important;\n}\n\n// Fix button alignment issues\n::ng-deep .confirmation-dialog mat-dialog-actions {\n  justify-content: flex-end !important;\n  align-items: center !important;\n}\n\n.confirmation-dialog {\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n}\n\n.dialog-header {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 2;\n}\n\n.confirmation-content {\n  overflow-y: auto;\n}\n\nmat-dialog-actions.mat-dialog-actions {\n  position: sticky;\n  bottom: 0;\n  background: #fafafa;\n  z-index: 2;\n}\n\n/* Align actions */\nmat-dialog-actions.mat-dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 24px;\n}\n\n/* Normalize MDC buttons inside actions */\nmat-dialog-actions .mat-mdc-button-base {\n  height: 40px;\n  min-width: 120px;\n  padding: 0 16px;\n  margin: 6px;\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Ensure the internal MDC label area uses flex for icon/text alignment */\nmat-dialog-actions .mat-mdc-button-base .mdc-button__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1;\n}\n\n/* Standardize icon size/alignment */\nmat-dialog-actions .mat-mdc-button-base .mat-icon {\n  font-size: 20px;\n  height: 20px;\n  width: 20px;\n}\n\n/* Visual for cancel button to match sizing */\n.cancel-btn {\n  border: 1px solid #ddd;\n  background-color: #f8f9fa;\n  color: #444;\n}\n\n@media (max-width: 600px) {\n  mat-dialog-actions.mat-dialog-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  mat-dialog-actions .mat-mdc-button-base {\n    width: 100%;\n    margin: 6px 0;\n  }\n}\n\n@media (max-width: 600px) {\n  .confirmation-dialog {\n    width: calc(100vw - 24px);\n    max-width: 415px;\n    margin: 12px auto;\n    border-radius: 0;\n    max-height: 100vh;\n\n    .dialog-header {\n      padding: 16px 16px 0;\n\n      h2 {\n        font-size: 18px;\n        line-height: 1.2;\n      }\n\n      .close-button {\n        width: 36px;\n        height: 36px;\n        min-width: 36px;\n        min-height: 36px;\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n\n    .confirmation-content {\n      padding: 12px 16px 16px;\n      max-height: calc(100vh - 140px);\n      overflow-y: auto;\n    }\n\n    mat-dialog-actions {\n      position: sticky;\n      bottom: 0;\n      background: #fafafa;\n      flex-direction: column !important;\n\n      button {\n        width: 100% !important;\n        margin-bottom: 8px !important;\n\n        &:last-child {\n          margin-bottom: 0 !important;\n        }\n      }\n    }\n  }\n\n  ::ng-deep .mat-dialog-container {\n    max-height: 100vh !important;\n  }\n}\n\n// Additional high-specificity overrides to ensure button colors\n::ng-deep .confirmation-dialog {\n  mat-dialog-actions {\n    button.mat-button.cancel-btn {\n      color: #666 !important;\n      border: 1px solid #ddd !important;\n      background-color: #f8f9fa !important;\n      background-image: none !important;\n    }\n\n    button.mat-raised-button.confirm-btn.approve {\n      background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;\n      background-image: linear-gradient(\n        135deg,\n        #4caf50 0%,\n        #45a049 100%\n      ) !important;\n      color: white !important;\n      border: none !important;\n      background-color: transparent !important;\n    }\n  }\n}\n\n/* Comment Form Styling */\n.comment-form-section {\n  margin: 20px 24px;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n\n  .example-form {\n    margin: 0;\n\n    .w-100 {\n      width: 100%;\n    }\n\n    .font16 {\n      font-size: 16px;\n      font-weight: 500;\n      color: #495057;\n    }\n\n    mat-form-field {\n      width: 100%;\n\n      .mat-mdc-form-field {\n        width: 100%;\n      }\n\n      .mat-mdc-text-field-wrapper {\n        background-color: #fff;\n        border-radius: 6px;\n      }\n\n      .mat-mdc-form-field-focus-overlay {\n        background-color: transparent;\n      }\n\n      input {\n        font-size: 14px;\n        color: #495057;\n\n        &::placeholder {\n          color: #6c757d;\n          opacity: 0.7;\n        }\n      }\n\n      .mat-mdc-form-field-hint {\n        color: #6c757d;\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .comment-form-section {\n    margin: 12px 12px;\n    padding: 12px;\n  }\n}\n\n/* Spacing adjustments for better padding */\n.dialog-header {\n  padding: 16px 24px 0;\n}\n\n.confirmation-content {\n  padding: 16px 24px 16px;\n}\n\n.comment-form-section {\n  margin: 16px 24px;\n  padding: 16px;\n}\n\nmat-dialog-actions.mat-dialog-actions {\n  padding: 12px 24px;\n}\n\n/* Add border on all sides for action buttons */\nmat-dialog-actions.mat-dialog-actions button.mat-button,\nmat-dialog-actions.mat-dialog-actions button.mat-raised-button,\nmat-dialog-actions .mat-mdc-button-base {\n  border: 1px solid #ddd;\n}\n\n\n// ════════════════════════════════════════════════\n// DARK MODE – dialog component\n// ════════════════════════════════════════════════\nbody.theme-dark .mat-mdc-dialog-container,\nbody.theme-dark .mdc-dialog__container,\nbody.theme-dark .mdc-dialog__surface {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dialog-content,\nbody.theme-dark .dialog-body,\nbody.theme-dark .modal-content,\nbody.theme-dark .confirmation-dialog,\nbody.theme-dark .response-dialog {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dialog-content input,\nbody.theme-dark .dialog-body input,\nbody.theme-dark .dialog-content select,\nbody.theme-dark .dialog-body select,\nbody.theme-dark .dialog-content textarea,\nbody.theme-dark .dialog-body textarea {\n  background: #0f172a !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dialog-content p,\nbody.theme-dark .dialog-body p,\nbody.theme-dark .dialog-content span:not(.material-icons),\nbody.theme-dark .dialog-body span:not(.material-icons),\nbody.theme-dark .dialog-content label,\nbody.theme-dark .dialog-body label,\nbody.theme-dark .dialog-content h1,\nbody.theme-dark .dialog-body h1,\nbody.theme-dark .dialog-content h2,\nbody.theme-dark .dialog-body h2,\nbody.theme-dark .dialog-content h3,\nbody.theme-dark .dialog-body h3 {\n  color: var(--fc-fg) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
